import { CronJob } from '@shared/service/cronjob/cronjob.service'
import { sessionManager } from '@shared/service/sessionManager/session-manager.class'

/**
 * Execute all application cron jobs
 */
export const startCronJobs = () => {
    sessionManager.log('Inside startCronJobs')
    const cronJobs = new CronJob()
  
    // CRON TASK - Periodically (every 5 seconds) : Checks if backend is up
    cronJobs.taskCheckLiveness.run({ runImmediately: true });

    // CRON TASK - Periodically (every 5 seconds) : check refreshToken validity
    cronJobs.taskCheckRefreshTokenExpiration.run({ runImmediately: true });

    // CRON TASK - Periodically (every 5 seconds) : get accessToken remaining time
    cronJobs.taskDisplayAccessTokenRemainingTime.run({ runImmediately: true });

    // CRON TASK - Periodically (every 5 seconds) : get refreshToken remaining time
    cronJobs.taskDisplayRefreshTokenRemainingTime.run({ runImmediately: true });
}
  
/**
 * Execute all application cron jobs
 */
export const stopCronJobs = () => {
    sessionManager.log('Inside stopCronJobs')
    const cronJobs = new CronJob()
  
    cronJobs.taskCheckLiveness.stop()
    cronJobs.taskCheckRefreshTokenExpiration.stop();
    cronJobs.taskDisplayAccessTokenRemainingTime.stop();
    cronJobs.taskDisplayRefreshTokenRemainingTime.stop();
}